<template>
    <div class="page container" data-page="admin">
        
        <h1 class="title">{{ this.$route.name }}</h1>

        <div class="pure-g">
            
            <div class="pure-u-1 pure-u-lg-5-24 left">
                <h4>Actions</h4>
                <div class="adminActionBtns">

                    <a href="#0" @click.prevent="fixUserData()" class="btn secondary">
                        <div v-if="loadingFixUserData" class="loading small"></div>
                        <span v-else>Fix User Data</span>
                    </a>
                    <br/><br/>
                
                    <a href="#0" @click.prevent="forceUserFields()" class="btn secondary">
                        <div v-if="loadingForceUserFields" class="loading small"></div>
                        <span v-else>Force User Fields</span>
                    </a>
                </div>
            </div>
            
            <div class="pure-u-1 pure-u-lg-14-24 center">
                <h4>Members</h4>
                <MembersList v-if="loadMembers" type="admin"></MembersList>
            </div>

             <div class="pure-u-1 pure-u-lg-5-24 right">
                 Right
            </div>

        </div>
    </div>
</template>

<script>
    import countryData from 'country-state-city'
    const fb = require('../../firebaseConfig.js')
    import MembersList from '../../components/MembersList.vue'
    
    export default {
        metaInfo: {
            title: 'Admin'
        },
        components: {
            MembersList
        },
        data(){
            return{
                loadMembers: false,
                loadingSendMail: false,
                loadingSendTxt: false,
                loadingFixUserData: false,
                loadingForceUserFields: false
            }
        },
        mounted(){
            this.loadCities()

            if(this.$store.state.currentUser){
                if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                    this.loadMembers = true
                }else{
                    this.$router.push('/')
                }
            }else{
                this.$router.push('/')
            }
        },
        methods:{
            fixUserData(){

                let self = this
                let options = {
                    email: '', // bilguun9696@gmail.com
                    customerId: '' // cus_HZ3gkSjYVh661R
                }
                
                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/GetUserData', options).then(response => {
                    
                    if(response.status === 200){
                        self.loadingFixUserData = false
                    }

                    console.log('Get user data '+ options.email +': ', response)

                    let user = response.body.data

                    let fullName = user.displayName
                    let firstName = user.displayName !== null ? fullName.split(' ').slice(0, -1).join(' ') : null
                    let lastName = user.displayName !== null ? fullName.split(' ').slice(-1).join(' ') : null
                    let sendEmail = user.email !== null ? true : false
                    let sendTxt = typeof(user.phoneNumber) !== 'undefined' ? true : false
                    let phoneNumber = typeof(user.phoneNumber) !== 'undefined' ? user.phoneNumber : null

                    let userProfileData = {
                        customerId: options.customerId,
                        displayName: fullName,
                        firstName: firstName,
                        lastName: lastName,
                        email: user.email,
                        emailVerified: user.emailVerified,
                        phoneNumber: phoneNumber,
                        photoURL: user.photoURL,
                        uid: user.uid,
                        isMember: true,
                        darkMode: true,
                        timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                        settings: {
                            sendEmail: sendEmail,
                            sendTxt: sendTxt
                        },
                        uid: user.uid
                    }

                    let userRef = fb.usersCollection.doc(user.uid)

                    userRef.collection('transactions').get().then(snap => {

                        let count = 1
                        snap.forEach(function(trans){
                            let transData = trans.data()
                            if(count === 1){

                                console.log('Transaction data: ', transData)

                                userProfileData.membershipPayment = transData
                                userProfileData.defaultPaymentMethod = transData.payment_method_types[0]

                                console.log('Update user with data: ', userProfileData)

                                self.setUserData(userProfileData)
                            }
                            count += 1
                        })

                    }).catch(err => {
                        console.log('Error getting users transactions: ', err.message)
                    })
                    
                }).catch((err) => {
                    console.log('Error getting user data! ', err)
                    self.loadingFixUserData = false
                })
            },
            setUserData(userData){

                let userRef = fb.usersCollection.doc(userData.uid)

                userRef.update(userData).then(() => {
                    console.log('Successfully updated user data: ', userData.uid, userData.email)
                }).catch(err => {
                    console.log('Error updating user data: ', err.message)
                })
            },
            loadCities(){

                let country = countryData.getCountryByCode('US')
                let states = countryData.getStatesOfCountry('38')

                console.log('Country: ', country)
                console.log('States: ', states)

                // states.forEach((state) => {
                //     let cities = countryData.getCitiesOfState(state.id)
                //     console.log(state.name + ': ', cities)
                // })

            },
            forceUserFields(){

                this.loadingForceUserFields = true

                let allUsers = this.$store.state.allUsersNew

                let count = 0

                if(allUsers !== null){
                    for(let i = 0; i < allUsers.length; i++){
                        
                        let user = allUsers[i]

                        if(!user.darkMode){
                            count += 1

                            let updateData = {
                                darkMode: true
                            }
                            
                            let userRef = fb.usersCollection.doc(user.uid)

                            userRef.update(updateData).then(() => {
                                console.log('Successfully updated user data: ', user.displayName)
                            }).catch(err => {
                                console.log('Error updating user data: ', err.message)
                            })
                        }
                    }
                }

                console.log('All Users not dark mode: ', count)

                this.loadingForceUserFields = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Admin/Admin.vue